import { useCallback, useSyncExternalStore } from 'react';

const mediaQueryList = (query) => {
  try {
    return window.matchMedia?.(query) ?? null;
  } catch (_e) {
    return null;
  }
};

/**
 * Whether a CSS media query matches right now, kept live: the component
 * re-renders when the viewport crosses it (like `usePrefersReducedMotion`).
 * For layouts that render different markup on each side of a breakpoint, so
 * only one of them is in the DOM. False when `matchMedia` is missing, and
 * on the server.
 */
export const useMediaQuery = (query) => {
  const subscribe = useCallback((onChange) => {
    const mq = mediaQueryList(query);
    if (!mq) return () => {};
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener?.('change', onChange);
    }
    if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
      return () => mq.removeListener?.(onChange);
    }
    return () => {};
  }, [query]);
  const getSnapshot = () => Boolean(mediaQueryList(query)?.matches);
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
};

export default useMediaQuery;
